import {
    // CartIcon,
    FAQIcon,
    GraphIcon,
    GridIcon,
    InfoIcon,
    MailIcon,
    UserSquareIcon,
} from "@assets/icons"

export const NAV_LINK = [
    {
        key: "chooseview",
        title: "Choose View",
        path: "/chooseview",
        icon: GridIcon,
    },
    {
        key: "my-account",
        title: "My Account",
        path: "/account",
        icon: UserSquareIcon,
    },
    {
        key: "faq",
        title: "FAQ",
        path: "/faq",
        icon: FAQIcon,
    },
    {
        key: "contact",
        title: "Contact",
        path: "/contact",
        icon: MailIcon,
    },
    {
        key: "report",
        title: "Report Concern",
        path: "/reportconcern",
        icon: InfoIcon,
    },
    // {
    //   key: "order-online",
    //   title: "Order Online",
    //   path: "/appointment",
    //   icon: CartIcon,
    // },
]
